/**
 * @generated SignedSource<<130012c6d5631e55d9785667c4b630a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetGitHubSyncTargetInput = {
  projectId?: string | null;
  target?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type setGithubSyncTargetMutation$variables = {
  input: SetGitHubSyncTargetInput;
};
export type setGithubSyncTargetMutation$data = {
  readonly setGitHubSyncTarget: {
    readonly project: {
      readonly gitHubSyncTarget: number | null;
    } | null;
  } | null;
};
export type setGithubSyncTargetMutation = {
  variables: setGithubSyncTargetMutation$variables;
  response: setGithubSyncTargetMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitHubSyncTarget",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setGithubSyncTargetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetGitHubSyncTargetPayload",
        "kind": "LinkedField",
        "name": "setGitHubSyncTarget",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setGithubSyncTargetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetGitHubSyncTargetPayload",
        "kind": "LinkedField",
        "name": "setGitHubSyncTarget",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c2636f40c8e9296fb805d663779da5a",
    "id": null,
    "metadata": {},
    "name": "setGithubSyncTargetMutation",
    "operationKind": "mutation",
    "text": "mutation setGithubSyncTargetMutation(\n  $input: SetGitHubSyncTargetInput!\n) {\n  setGitHubSyncTarget(input: $input) {\n    project {\n      gitHubSyncTarget\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd304be7bbb632e4b1919d44ff13bc27";

export default node;
